<section>
  <p>
    We were unable to authorise your account for use with the CS Portal.
  </p>
  <p>
    Please close all browser windows and try again. If the problem persists, please contact the Service Desk on 1300 74 74 35.
  </p>
</section>